<template>
  <div>
    <label class="label" v-if="label !== undefined" :for="name">{{label}}</label>
    <input :type="type"
           @input="input"
           :id="name"
           :name="name"
           :class="{'invalid' : error !== undefined}"
           :placeholder="focus ? '' : placeholder"
           class="input"
           @focus="focus = true"
           @blur="focus = false"
           :value="value"
    >
  </div>
</template>

<script>
  import inputMixin from '../../mixins/inputMixin';

  export default {
    name: "InputText",
    mixins: [inputMixin]
  }
</script>

<style lang="scss">
  @import "../../style/var";

  .input {
    width: 100%;
    margin-bottom: 25px;
    padding: 12px 20px;
    font-size: 16px;
    font-family: inherit;
    font-weight: 300;
    border: none;
    box-shadow: $shadow;
    background-color: #fff;
    transition: all 0.3s ease;
    &::placeholder {
      color: inherit;
    }
  }

  .label {
    display: block;
    margin-bottom: 7px;
    color: #8E8E8E;
    font-size: 14px;
  }

  .invalid {
    box-shadow: 0 2px 15px transparentize($red, 0.3) !important;
  }
</style>